// Rewrites assets stored against the Emergent preview app domain so they load
// from the current origin (e.g. ascoltaanima.it). CDN hosts like
// static.prod-images.emergentagent.com are left untouched.
export function localizeAsset(url) {
  if (!url || typeof url !== "string") return url;
  try {
    const u = new URL(url, window.location.origin);
    if (u.hostname.endsWith(".preview.emergentagent.com")) {
      return u.pathname + u.search;
    }
    return url;
  } catch {
    return url;
  }
}
